<mat-icon
  svgIcon="chat"
  class="nav-link-icon"
  [matBadge]="!!(messengerService.unreadCount$ | async) ? (messengerService.unreadCount$ | async) : ''"
  matBadgeSize="medium"
  matBadgeColor="warn"
  [linChatListTrigger]="listComponent"
></mat-icon>

<lin-chat-toolbar-template #listComponent></lin-chat-toolbar-template>
